<div class="p-d-flex p-jc-between">
    <p-selectButton [options]="allModules" [(ngModel)]="selectedModule" optionLabel="name"
        (onChange)="changeModule()"></p-selectButton>
    <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input type="text" pInputText placeholder="Search" (input)="dt.filterGlobal($event.target.value, 'contains')" />
    </span>
</div>
<p-table [value]="allCustomFields" #dt [globalFilterFields]="['name', 'module', 'formControl.label']">
    <ng-template pTemplate="header">
        <tr>
            <th>Name</th>
            <th>Module</th>
            <th>Field Type</th>
            <th>Required</th>
            <th>Is Active</th>
            <th>Actions</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-field let-i="rowIndex">
        <tr>
            <td>{{ field.name }}</td>
            <td>{{ field.module }}</td>
            <td>{{ field.formControl?.label }}</td>
            <td>{{ field.isRequired ? answertypeConstants.Yes : answertypeConstants.No }}</td>
            <td>{{ field.statusId == statusConstants.ACTIVE ? answertypeConstants.Yes : answertypeConstants.No }}</td>
            <td class="action">
                <span class="btnBars p-mr-0" *ngIf="field.isEdit" (click)="showEditCustomFieldPopUp(field)"
                    pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                <span class="btnBars p-mr-0" *ngIf="field.isDelete" (click)="deleteCustomField(field)" pTooltip="Delete"
                    tooltipPosition="top"><i class="pi pi-trash"></i></span>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
        <tr>
            <td colspan="7" class="p-text-center">
                No data found.
            </td>
        </tr>
    </ng-template>
</p-table>

<div *ngIf="loading" class="centered-spinner" style="margin: auto;">
    <p-progressSpinner [style]="{width: '40px', height: '40px'}" strokeWidth="4"></p-progressSpinner>
</div>

<p-dialog header="{{ addEditCustomFieldHeader }}" [modal]="true" [(visible)]="displayAddEditCustomField"
    [style]="{ width: '50vw' }" [baseZIndex]="10000">
    <form [formGroup]="customFieldForm">
        <div class="card">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12 p-lg-4">
                    <label for="name">Module Name<span style="color: red">*</span></label>
                    <p-dropdown [options]="allModules" formControlName="objectId" optionLabel="name" [readonly]="!isAdd"
                        [ngClass]="{'p-disabled': !isAdd}" placeholder="Select Module" appendTo="body"
                        (onChange)="getConfigurationTypes()"> </p-dropdown>
                </div>
                <div class="p-col-12 p-lg-4">
                    <label>Template Name <span style="color: red">*</span></label>
                    <p-dropdown [options]="allTemplates" placeholder="Select Template" formControlName="typeId"
                        (onChange)="loadTypewiseSections($event.value)" placeholder="Select Template" optionLabel="displayName"
                        [ngModelOptions]="{ standalone: true }" appendTo="body"></p-dropdown>
                </div>
                <div class="p-col-12 p-lg-4">
                    <label for="name">Section Name <span style="color: red">*</span></label>
                    <p-dropdown [options]="sections" formControlName="section" optionLabel="name"
                        placeholder="Select Section" appendTo="body"> </p-dropdown>
                </div>
            </div>
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12 p-lg-6">
                    <label for="name">Title <span style="color: red">*</span></label>
                    <input type="text" pInputText formControlName="fieldName" [readonly]="!isAdd"
                        [ngClass]="{'p-disabled': !isAdd}" />
                    <small *ngIf="showCustomFieldValidation && customFieldNameExist" class="p-invalid"> Field name
                        already exists </small>
                    <small *ngIf="customFieldForm.get('fieldName').hasError('alphaNumeric')" class="p-invalid"> Only
                        alphabets, numbers, spaces, hyphens, and underscores are allowed. </small>
                </div>
                <div class="p-col-12 p-lg-6">
                    <label for="name">Field Type <span style="color: red">*</span></label>
                    <p-dropdown [options]="showAllCustomFieldTypes" [readonly]="!isAdd"
                        [ngClass]="{'p-disabled': !isAdd}" formControlName="formControlId" optionLabel="label"
                        placeholder="Select Field Type" appendTo="body" (onChange)="resetPickList($event)">
                    </p-dropdown>
                    <small *ngIf="showCustomFieldValidation && showOptionValidationError" class="p-invalid">
                        <span
                            *ngIf="(customFieldForm.controls['formControlId'].value.id == formControls.Dropdown || customFieldForm.controls['formControlId'].value.id == formControls.MultiSelect || customFieldForm.controls['formControlId'].value.id == formControls.Checkbox) && pickListValues.length == 0">Atleast
                            1 option is required</span>
                        <span
                            *ngIf="customFieldForm.controls['formControlId'].value.id == formControls.RadioButton && pickListValues.length < 2">Atleast
                            2 options are required</span>
                    </small>
                </div>
            </div>
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-6"
                    *ngIf="customFieldForm.controls['formControlId'].value && customFieldForm.controls['formControlId'].value.id == formControls.Decimal">
                    <div class="p-field">
                        <label for="name">Max Length After Decimal
                            <i *ngIf="!isAdd" class="pi pi-info-circle p-mr-1" aria-hidden="true"
                                pTooltip="Reducing the number of decimal places may result fixed down and potential loss of precision when updating {{ customFieldForm.value.objectId?.name || '' }}."
                                tooltipPosition="right"></i>
                            <span style="color: red">*</span>
                        </label>
                        <!-- <p-inputNumber formControlName="maxLengthAfterDecimal" [min]="1" [max]="6" appNumbersOnly></p-inputNumber> -->
                        <p-inputNumber formControlName="maxLengthAfterDecimal" [min]="2" [max]="6"></p-inputNumber>
                        <div>
                            <small *ngIf="showCustomFieldValidation && showOptionValidationError" class="p-invalid">
                                <span
                                    *ngIf="customFieldForm.controls['formControlId'].value.id == formControls.Decimal && !customFieldForm.controls['maxLengthAfterDecimal'].value">Max
                                    length after decimal should between 1 to 6</span>
                            </small>
                        </div>
                    </div>
                </div>
                <div class="p-col-6 p-field-checkbox" style="align-items: flex-end">
                    <p-checkbox formControlName="isRequired" [ngStyle]="{
                          verticalAlign: 'middle',
                      }" binary="true" inputId="isRequired"></p-checkbox>
                    <label for="isRequired" style="padding: 5px; margin: 0px">Required</label>
                </div>
                <div class="p-col-12"
                    *ngIf="customFieldForm.controls['formControlId'].value.id == formControls.Dropdown || customFieldForm.controls['formControlId'].value.id == formControls.Checkbox || customFieldForm.controls['formControlId'].value.id == formControls.RadioButton || customFieldForm.controls['formControlId'].value.id == formControls.MultiSelect">
                    <div class="p-d-flex">
                        <div style="font-size: 14px; flex-grow: 1">
                            <span
                                *ngIf="customFieldForm.controls['formControlId'].value.id == formControls.Dropdown"><label
                                    style="padding: 5px; margin: 0px; font-weight: 600">Add DropDown List</label></span>
                            <span
                                *ngIf="customFieldForm.controls['formControlId'].value.id == formControls.MultiSelect"><label
                                    style="padding: 5px; margin: 0px; font-weight: 600">Add Multi-Select
                                    List</label></span>
                            <span
                                *ngIf="customFieldForm.controls['formControlId'].value.id == formControls.Checkbox"><label
                                    style="padding: 5px; margin: 0px; font-weight: 600">Add CheckBox</label></span>
                            <span
                                *ngIf="customFieldForm.controls['formControlId'].value.id == formControls.RadioButton"><label
                                    style="padding: 5px; margin: 0px; font-weight: 600">Add Radio Buttons</label></span>
                        </div>
                        <div pButton (click)="addOptionList()" class="p-button-text p-button-rounded"
                            style="width: 4rem" label="" icon="pi pi-plus"></div>
                    </div>
                    <div *ngIf="pickListValues.length > 0">
                        <p-table [value]="pickListValues">
                            <ng-template pTemplate="body" let-option let-i="rowIndex">
                                <tr [pReorderableRow]="i" class="action">
                                    <td style="width: 3rem">
                                        <span class="pi pi-bars" pReorderableRowHandle></span>
                                    </td>
                                    <td>
                                        <input pInputText type="text" [(ngModel)]="option.name" name="option{{ i }}"
                                            [ngModelOptions]="{ standalone: true }" required />
                                        <small *ngIf="showCustomFieldValidation && !option.name" class="p-invalid">
                                            Option name is required </small>
                                    </td>
                                    <td style="width: 3rem">
                                        <div pButton (click)="deleteCustomOption(i)"
                                            class="p-button-text p-button-rounded" label="" icon="pi pi-minus"> </div>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="displayAddEditCustomField = false" label="Cancel" class="p-button-secondary"></button>
        <button pButton [disabled]="!customFieldForm.valid" (click)="saveCustomFieldData(customFieldForm.value)"
            label="Save"></button>
    </ng-template>
</p-dialog>